import * as actionTypes from '../consts/actionTypes';

const initialState = {
    communication: [],
    communications: {},
    modifyCommunications: false,
    communicationSelected: null,
    countCommunication: 0,
    communicationSelected: null,
    hasCommunication: [
        { title: 'Comunicaciones', countCommunication: 0 },
    ],
    msgError: ''
};

export default function communicatedReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_COMMUNICATION]: responseToReturn('communication'),
        [actionTypes.FAILURE_GET_COMMUNICATION]: responseToReturn('communication'),

        [actionTypes.SUCCESS_MODIFY_COMMUNICATION]: responseToReturn('modifyCommunications'),
        [actionTypes.FAILURE_MODIFY_COMMUNICATION]: responseToReturn('modifyCommunications'),

        [actionTypes.SUCCESS_SELECT_COMMUNICATION]: responseToReturn('communicationSelected'),
        [actionTypes.FAILURE_SELECT_COMMUNICATION]: responseToReturn('communicationSelected'),


        [actionTypes.SUCCESS_SET_COUNT_COMMUNICATION]: responseToReturn('countCommunication'),
        [actionTypes.SUCCESS_SELECT_COMMUNICATION]: responseToReturn('communicationSelected'),
        [actionTypes.SUCCESS_HASH_COMMUNICATION]: responseToReturn('hasCommunication'),

        [actionTypes.FAILURE_SET_COUNT_COMMUNICATION]: responseToReturn('countCommunication'),
        [actionTypes.FAILURE_SELECT_COMMUNICATION]: responseToReturn('communicationSelected'),
        [actionTypes.FAILURE_HASH_COMMUNICATION]: responseToReturn('hasCommunication'),

        [actionTypes.SUCCESS_ALL_GET_COMMUNICATION]: responseToReturn('communications'),
        [actionTypes.FAILURE_ALL_GET_COMMUNICATION]: responseToReturn('communications'),
        [actionTypes.FAILURE_UPDATE_ALL_GET_COMMUNICATION]: responseToReturn('communications'),

        [actionTypes.GET_COMMUNICATION]: responseToReturn(''),
    };
    function responseToReturn(item) {
        let res = { ...state };
        if (action.response) {
            res = { ...state, [item]: action.response.data, msgError: action.message };
        }
        if (action.message) {
            res = { ...state, msgError: action.message };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}